export default __webpack_public_path__ + "static/media/background-blur.75f61780.png";